import { ICompetitionDto } from "../../models/dto/agendaApi/ICompetitionDto";
import * as ApiWithToken from "../callApiWithToken";

const competitorsService = {
    getBrands: async function (includedHp: Boolean, appointmentId:number) {
        return ApiWithToken.getApi(process.env.REACT_APP_AGENDAS_API + `CompetitionAdvisors/getBrands?includedHp=${includedHp}&appointmentId=${appointmentId}`);
    },
    getDropDownValues: async function () {
        return ApiWithToken.getApi(process.env.REACT_APP_AGENDAS_API + `CompetitionAdvisors/getDropDownValues`);
    },
    saveCompetitions: async function (competitions: ICompetitionDto[]) {
        return ApiWithToken.postApi(process.env.REACT_APP_AGENDAS_API + `CompetitionAdvisors/saveCompetitions`, competitions);
    }
}

export default competitorsService;